//---- components ---------
//---- mixins -------------
//---- services -----------
import AdminService from '../services/admin.service.js';
import { httpClient } from '@/app/services';
//---- other --------------
//---- 3rd-parties --------

export const initialState = { adminInfoData: null, projectInfoData: null, sessionInfoData: null, stylePip: { status: 0 }, styleFactorySettings: null }

export const admin = {
  //---------------- namespaced --------------------------------------------
  namespaced: true,
  //----------------- state ------------------------------------------------
  state: { ...initialState },
  //----------------- vuex actions  ----------------------
  actions: {
    // get admin page information data
    getAdminInfo({ commit }) {
      return AdminService.getAdminInformation().then(httpClient.spread((systemInfoResp, projectInfoResp, sessionInfoResp) => {
        if (systemInfoResp.data) {
          commit('setAdminInfoData', systemInfoResp.data);
        }
        if (projectInfoResp.data) {
          commit('setProjectInfoData', projectInfoResp.data);
        }
        if (sessionInfoResp.data) {
          commit('setSessionInfoData', sessionInfoResp.data);
        }
      }))
    },
    // get project info
    getProjectInfo({ commit }) {
      return AdminService.getProjectInformation().then(response => {
        if (response) {
          commit('setProjectInfoData', response.data);
        } else if (response.data.status == 'failure') {
          const error = response.data.status && response.data.ErrorKey;
          alert("Error in geProjectInfo" + error); // TODO proper error management
          return Promise.reject(error);
        }

      })
    },
    // get session info
    getSesionInfo({ commit }) {
      return AdminService.getSessionInformation().then(response => {
        if (response) {
          commit('setSessionInfoData', response.data);
        } else if (response.data.status == 'failure') {
          const error = response.data.status && response.data.ErrorKey;
          alert("Error in getSesionInfo" + error); // TODO proper error management
          return Promise.reject(error);
        }

      })
    },
    updateStylePipStatus({ commit }, status) {
      commit('updateStylePipStatus', status);
    },
    setStyleFactorySettings({ commit }, values) {
      commit('setStyleFactorySettings', values);
    },
  },
  //---------------------mutations ----------------------------------------------
  mutations: {
    setAdminInfoData(state, adminInfoData) {
      state.adminInfoData = adminInfoData;
    },
    setProjectInfoData(state, projectInfoData) {
      state.projectInfoData = projectInfoData;
    },
    setSessionInfoData(state, sessionInfoData) {
      state.sessionInfoData = sessionInfoData;
    },
    error(state) {
      state.adminInfoData = null;
      state.projectInfoData = null;
      state.sessionInfoData = null;
    },
    updateStylePipStatus(state, status) {
      state.stylePip.status = status;
    },
    setStyleFactorySettings(state, values) {
      if (state.styleFactorySettings)
        return;
      state.styleFactorySettings = values;
    },
  },
  getters: {
    stylePipStatus(state) {
      return state.stylePip.status
    },
    stylePipStatusClass(state) {
      switch (state.stylePip.status) {
        case 0:
          return 'full-screen'
        case 1:
          return 'top-right'
        case 2:
          return 'bottom-right'
        case 3:
          return 'bottom-left'
        case 4:
          return 'top-left'
      }
      return 'full-screen'
    },
    styleFactorySettings(state) {
      return state.styleFactorySettings;
    },
  }
}